export default __webpack_public_path__ + "static/media/consentFR.6a55e108.pdf";